<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MFP MX931">
     MFP MX931
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_fr" title="Consignes de s&eacute;curit&eacute;">
     Consignes de s&eacute;curit&eacute;
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conventions">
      Conventions
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="D&eacute;claration du produit">
      D&eacute;claration du produit
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_fr" title="A propos de l'imprimante">
     A propos de l'imprimante
    </a>
   </p>
   <div id="divd0e170">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_fr" title="Recherche d'informations &agrave; propos de l'imprimante">
      Recherche d'informations &agrave; propos de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_fr" title="Recherche du num&eacute;ro de s&eacute;rie de l'imprimante">
      Recherche du num&eacute;ro de s&eacute;rie de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_fr" title="Configurations de l'imprimante">
      Configurations de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_fr" title="Utilisation du panneau de commandes">
      Utilisation du panneau de commandes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_fr" title="Pr&eacute;sentation de l'&eacute;tat du voyant lumineux">
      Pr&eacute;sentation de l'&eacute;tat du voyant lumineux
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e562" title="Choix du papier">
      Choix du papier
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_fr" title="Configuration, installation et param&eacute;trage">
     Configuration, installation et param&eacute;trage
    </a>
   </p>
   <div id="divd0e3851">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_fr" title="S&eacute;lection d'un emplacement pour l'imprimante">
      S&eacute;lection d'un emplacement pour l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_fr" title="Connexion des c&acirc;bles">
      Connexion des c&acirc;bles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e4039" title="Configuration et utilisation des applications pr&eacute;sentes sur l'&eacute;cran d'accueil">
      Configuration et utilisation des applications pr&eacute;sentes sur l'&eacute;cran d'accueil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e4656" title="Configuration et utilisation des fonctions d'accessibilit&eacute;">
      Configuration et utilisation des fonctions d'accessibilit&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e4959" title="Configuration de l'imprimante en t&eacute;l&eacute;copieur">
      Configuration de l'imprimante en t&eacute;l&eacute;copieur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_fr" title="Configuration des param&egrave;tres SMTP de messagerie">
      Configuration des param&egrave;tres SMTP de messagerie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#d0e6754" title="Chargement du papier et des supports sp&eacute;ciaux">
      Chargement du papier et des supports sp&eacute;ciaux
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7147" title="Installation et mise &agrave; jour des logiciels, pilotes et microcodes">
      Installation et mise &agrave; jour des logiciels, pilotes et microcodes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e7430" title="Installation des options mat&eacute;rielles">
      Installation des options mat&eacute;rielles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e8102" title="Utilisation en r&eacute;seau">
      Utilisation en r&eacute;seau
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_fr" title="Configuration de l'impression s&eacute;rie (Windows uniquement)">
      Configuration de l'impression s&eacute;rie (Windows uniquement)
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_fr" title="S&eacute;curiser l'imprimante">
     S&eacute;curiser l'imprimante
    </a>
   </p>
   <div id="divd0e8500">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_fr" title="Emplacement du logement de s&eacute;curit&eacute;">
      Emplacement du logement de s&eacute;curit&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_fr" title="Effacement de la m&eacute;moire de l'imprimante">
      Effacement de la m&eacute;moire de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_fr" title="Effacement du disque de stockage de l'imprimante">
      Effacement du disque de stockage de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_fr" title="Restauration des param&egrave;tres usine">
      Restauration des param&egrave;tres usine
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_fr" title="D&eacute;claration relative &agrave; la volatilit&eacute;">
      D&eacute;claration relative &agrave; la volatilit&eacute;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_fr" title="Impression">
     Impression
    </a>
   </p>
   <div id="divd0e8693">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_fr" title="Impression depuis un ordinateur">
      Impression depuis un ordinateur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e8719" title="Impression &agrave; partir d'un p&eacute;riph&eacute;rique mobile">
      Impression &agrave; partir d'un p&eacute;riph&eacute;rique mobile
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_fr" title="Impression &agrave; partir d'un lecteur flash">
      Impression &agrave; partir d'un lecteur flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_fr" title="Lecteurs flash et types de fichiers pris en charge">
      Lecteurs flash et types de fichiers pris en charge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_fr" title="Configuration des travaux confidentiels">
      Configuration des travaux confidentiels
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_fr" title="Impression de travaux confidentiels et suspendus">
      Impression de travaux confidentiels et suspendus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_fr" title="Impression de la liste des &eacute;chantillons de polices">
      Impression de la liste des &eacute;chantillons de polices
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_fr" title="Impression d'une liste des r&eacute;pertoires">
      Impression d'une liste des r&eacute;pertoires
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_fr" title="Insertion d'intercalaires entre les copies">
      Insertion d'intercalaires entre les copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_fr" title="Agrafage de feuilles imprim&eacute;es">
      Agrafage de feuilles imprim&eacute;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_fr" title="Perforation de feuilles imprim&eacute;es">
      Perforation de feuilles imprim&eacute;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_fr" title="Utilisation de l'empileuse &agrave; d&eacute;calage pour les feuilles imprim&eacute;es">
      Utilisation de l'empileuse &agrave; d&eacute;calage pour les feuilles imprim&eacute;es
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_fr" title="Annulation d'une t&acirc;che d'impression">
      Annulation d'une t&acirc;che d'impression
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_fr" title="R&eacute;glage de l'intensit&eacute; du toner">
      R&eacute;glage de l'intensit&eacute; du toner
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying-chapter.html#copying-chapter_fr" title="Copie">
     Copie
    </a>
   </p>
   <div id="divd0e9484">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_fr" title="Utilisation du dispositif d'alimentation automatique et de la vitre du scanner">
      Utilisation du dispositif d'alimentation automatique et de la vitre du scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_fr" title="Faire des copies">
      Faire des copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_fr" title="Copie de photos">
      Copie de photos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_fr" title="Copie sur du papier &agrave; en-t&ecirc;te">
      Copie sur du papier &agrave; en-t&ecirc;te
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_fr" title="Copie des deux c&ocirc;t&eacute;s du papier">
      Copie des deux c&ocirc;t&eacute;s du papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_fr" title="R&eacute;duction ou agrandissement de copies">
      R&eacute;duction ou agrandissement de copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_fr" title="Assemblage des copies">
      Assemblage des copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_fr" title="Insertion d'intercalaires entre les copies">
      Insertion d'intercalaires entre les copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_fr" title="Copie de plusieurs pages sur une feuille">
      Copie de plusieurs pages sur une feuille
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_fr" title="Copie de cartes">
      Copie de cartes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-copies-topic.html#stapling-copies_fr" title="Agrafage de copies">
      Agrafage de copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-copies-topic.html#punching-holes-copies_fr" title="Perforation de copies">
      Perforation de copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-copies-topic.html#using-offset-stacking-copies_fr" title="Utilisation de l'empileuse &agrave; d&eacute;calage pour les copies">
      Utilisation de l'empileuse &agrave; d&eacute;calage pour les copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_fr" title="Cr&eacute;ation d'un raccourci de copie">
      Cr&eacute;ation d'un raccourci de copie
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_fr" title="E-mail">
     E-mail
    </a>
   </p>
   <div id="divd0e9863">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_fr" title="Utilisation du dispositif d'alimentation automatique et de la vitre du scanner">
      Utilisation du dispositif d'alimentation automatique et de la vitre du scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_fr" title="Envoi d'un courrier &eacute;lectronique">
      Envoi d'un courrier &eacute;lectronique
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_fr" title="Cr&eacute;ation d'un raccourci pour envoyer un e-mail">
      Cr&eacute;ation d'un raccourci pour envoyer un e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faxing-chapter.html#faxing-chapter_fr" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e9957">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_fr" title="Utilisation du dispositif d'alimentation automatique et de la vitre du scanner">
      Utilisation du dispositif d'alimentation automatique et de la vitre du scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_fr" title="Envoi d'une t&eacute;l&eacute;copie">
      Envoi d'une t&eacute;l&eacute;copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_fr" title="Planification d'une t&eacute;l&eacute;copie">
      Planification d'une t&eacute;l&eacute;copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_fr" title="Cr&eacute;ation d'un raccourci de destinations de t&eacute;l&eacute;copies">
      Cr&eacute;ation d'un raccourci de destinations de t&eacute;l&eacute;copies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_fr" title="Modification de la r&eacute;solution de la t&eacute;l&eacute;copie">
      Modification de la r&eacute;solution de la t&eacute;l&eacute;copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_fr" title="R&eacute;glage de l'intensit&eacute; de t&eacute;l&eacute;copie">
      R&eacute;glage de l'intensit&eacute; de t&eacute;l&eacute;copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_fr" title="Imprimer un journal de t&eacute;l&eacute;copie">
      Imprimer un journal de t&eacute;l&eacute;copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_fr" title="Blocage des t&eacute;l&eacute;copies non sollicit&eacute;es (t&eacute;l&eacute;copies de publicit&eacute;)">
      Blocage des t&eacute;l&eacute;copies non sollicit&eacute;es (t&eacute;l&eacute;copies de publicit&eacute;)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_fr" title="Mise en attente des fax">
      Mise en attente des fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_fr" title="Transfert d'une t&eacute;l&eacute;copie">
      Transfert d'une t&eacute;l&eacute;copie
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="ftp-chapter.html#ftp-chapter_fr" title="Scan">
     Scan
    </a>
   </p>
   <div id="divd0e10321">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_fr" title="Utilisation du dispositif d'alimentation automatique et de la vitre du scanner">
      Utilisation du dispositif d'alimentation automatique et de la vitre du scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_fr" title="Num&eacute;risation vers un ordinateur">
      Num&eacute;risation vers un ordinateur
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_fr" title="Num&eacute;risation vers un serveur FTP">
      Num&eacute;risation vers un serveur FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_fr" title="Cr&eacute;ation d'un raccourci FTP">
      Cr&eacute;ation d'un raccourci FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_fr" title="Num&eacute;risation vers un dossier r&eacute;seau">
      Num&eacute;risation vers un dossier r&eacute;seau
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_fr" title="Cr&eacute;ation d'un raccourci de dossier r&eacute;seau">
      Cr&eacute;ation d'un raccourci de dossier r&eacute;seau
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_fr" title="Num&eacute;risation vers un lecteur flash">
      Num&eacute;risation vers un lecteur flash
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="use-printer-menus-chapter.html#use-printer-menus-chapter_fr" title="Utilisation des menus de l'imprimante">
     Utilisation des menus de l'imprimante
    </a>
   </p>
   <div id="divd0e10624">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_fr" title="Affichage des menus">
      Affichage des menus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e10987" title="P&eacute;riph&eacute;rique">
      P&eacute;riph&eacute;rique
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e13275" title="Impression">
      Impression
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e14543" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e14912" title="Copie">
      Copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e15501" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e17907" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e18957" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e19635" title="Lecteur USB">
      Lecteur USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e20480" title="R&eacute;seau/ports">
      R&eacute;seau/ports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e22671" title="Services de cloud">
      Services de cloud
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e22728" title="S&eacute;curit&eacute;">
      S&eacute;curit&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e23917" title="Rapports">
      Rapports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_fr" title="D&eacute;pannage">
      D&eacute;pannage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_fr" title="Impression de la Page des param&egrave;tres de menu">
      Impression de la Page des param&egrave;tres de menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_fr" title="Entretien de l'imprimante">
     Entretien de l'imprimante
    </a>
   </p>
   <div id="divd0e24257">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_fr" title="V&eacute;rification de l'&eacute;tat des pi&egrave;ces et fournitures">
      V&eacute;rification de l'&eacute;tat des pi&egrave;ces et fournitures
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_fr" title="Configuration des notifications de fournitures">
      Configuration des notifications de fournitures
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_fr" title="Configuration des alertes par courrier &eacute;lectronique">
      Configuration des alertes par courrier &eacute;lectronique
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_fr" title="Affichage de rapports">
      Affichage de rapports
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-supplies-group_fr" title="Commande de pi&egrave;ces et de consommables">
      Commande de pi&egrave;ces et de consommables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e24458" title="Remplacement des pi&egrave;ces et consommables">
      Remplacement des pi&egrave;ces et consommables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e25003" title="Nettoyage des pi&egrave;ces de l'imprimante">
      Nettoyage des pi&egrave;ces de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e25256" title="Economie d'&eacute;nergie et de papier">
      Economie d'&eacute;nergie et de papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_fr" title="D&eacute;placement de l'imprimante">
      D&eacute;placement de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_fr" title="Transport de l'imprimante">
      Transport de l'imprimante
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_fr" title="R&eacute;solution d'un probl&egrave;me">
     R&eacute;solution d'un probl&egrave;me
    </a>
   </p>
   <div id="divd0e25411">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_fr" title="Probl&egrave;mes de qualit&eacute; d'impression">
      Probl&egrave;mes de qualit&eacute; d'impression
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_fr" title="Codes d'erreur de l'imprimante">
      Codes d'erreur de l'imprimante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e26365" title="Probl&egrave;mes d'impression">
      Probl&egrave;mes d'impression
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_fr" title="L'imprimante ne r&eacute;pond pas">
      L'imprimante ne r&eacute;pond pas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_fr" title="Impossible de lire le lecteur flash">
      Impossible de lire le lecteur flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_fr" title="Activation du port&nbsp;USB">
      Activation du port&nbsp;USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#d0e28930" title="Elimination des bourrages">
      Elimination des bourrages
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e29440" title="Probl&egrave;mes de connexion r&eacute;seau">
      Probl&egrave;mes de connexion r&eacute;seau
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e29668" title="Probl&egrave;mes li&eacute;s aux options mat&eacute;rielles">
      Probl&egrave;mes li&eacute;s aux options mat&eacute;rielles
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e29794" title="Probl&egrave;mes li&eacute;s aux consommables">
      Probl&egrave;mes li&eacute;s aux consommables
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e29899" title="Probl&egrave;mes de chargement du papier">
      Probl&egrave;mes de chargement du papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e30265" title="Probl&egrave;mes d'envoi par e-mail">
      Probl&egrave;mes d'envoi par e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e30359" title="Probl&egrave;mes de t&eacute;l&eacute;copie">
      Probl&egrave;mes de t&eacute;l&eacute;copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e31004" title="Probl&egrave;mes de num&eacute;risation">
      Probl&egrave;mes de num&eacute;risation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_fr" title="Contacter l'assistance client&egrave;le">
      Contacter l'assistance client&egrave;le
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_fr" title="Recyclage et mise au rebut">
     Recyclage et mise au rebut
    </a>
   </p>
   <div id="divd0e31800">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_fr" title="Recyclage des produits Lexmark">
      Recyclage des produits Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_fr" title="Recyclage des emballages de produits Lexmark">
      Recyclage des emballages de produits Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_fr" title="Avis">
     Avis
    </a>
   </p>
   <div id="divd0e31835">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31838" title="Informations produit">
      Informations produit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31855" title="Note d'&eacute;dition">
      Note d'&eacute;dition
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_fr" title="Marques commerciales">
      Marques commerciales
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_fr" title="Avis relatifs &agrave; l'accord de licence">
      Avis relatifs &agrave; l'accord de licence
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_fr" title="Niveaux d'&eacute;mission sonore">
      Niveaux d'&eacute;mission sonore
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_fr" title="Directive WEEE (D&eacute;chets issus d'&eacute;quipements &eacute;lectriques et &eacute;lectroniques)">
      Directive WEEE (D&eacute;chets issus d'&eacute;quipements &eacute;lectriques et &eacute;lectroniques)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31960" title="Batterie rechargeable au lithium-ion">
      Batterie rechargeable au lithium-ion
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_fr" title="R&egrave;glement (UE) 2023/1542">
      R&egrave;glement (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e31998" title="Guide de Tri pour la France">
      Guide de Tri pour la France
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e32011" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_fr" title="Mise au rebut des produits">
      Mise au rebut des produits
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_fr" title="Retour des cartouches Lexmark pour r&eacute;utilisation ou recyclage">
      Retour des cartouches Lexmark pour r&eacute;utilisation ou recyclage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_fr" title="Avis relatif &agrave; l'&eacute;lectricit&eacute; statique">
      Avis relatif &agrave; l'&eacute;lectricit&eacute; statique
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_fr" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_fr" title="Informations de temp&eacute;rature">
      Informations de temp&eacute;rature
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_fr" title="Consommation d'&eacute;lectricit&eacute;">
      Consommation d'&eacute;lectricit&eacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_fr" title="Avis de r&eacute;glementation pour les appareils radio et de t&eacute;l&eacute;communication">
      Avis de r&eacute;glementation pour les appareils radio et de t&eacute;l&eacute;communication
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#notice-to-users-of-the-canadian-telephone-network_fr" title="Notice to users of the Canadian telephone network">
      Notice to users of the Canadian telephone network
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_fr" title="Avis de conformit&eacute; aux directives de la Communaut&eacute; europ&eacute;enne (CE)">
      Avis de conformit&eacute; aux directives de la Communaut&eacute; europ&eacute;enne (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_fr" title="Avis sur les interf&eacute;rences radio">
      Avis sur les interf&eacute;rences radio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#statement-of-limited-warranty_fr" title="DECLARATION DE GARANTIE LIMITEE POUR IMPRIMANTES LASERS LEXMARK, IMPRIMANTES LED LEXMARK ET IMPRIMANTES LASER MULTIFONCTIONS LEXMARK">
      DECLARATION DE GARANTIE LIMITEE POUR IMPRIMANTES LASERS LEXMARK, IMPRIMANTES LED LEXMARK ET IMPRIMANTES LASER MULTIFONCTIONS LEXMARK
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue